// src/components/solutions/SolutionsAdvantage.tsx
import React from 'react';
import { ContentCard } from '@dopomogai/ui';
import { renderIcon } from '@dopomogai/utils';

interface Point {
  icon: string;
  title: string;
  text: string;
}

interface AdvantageData {
  headline: string;
  points: Point[];
}

interface SolutionsAdvantageProps {
  advantageData: AdvantageData;
}

export const SolutionsAdvantage: React.FC<SolutionsAdvantageProps> = ({ advantageData }) => {
  return (
    <section className="bg-slate-100 py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{advantageData.headline}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {advantageData.points.map((point, index) => (
            <ContentCard
              key={index}
              index={index}
              hoverEffect="lift"
              icon={renderIcon(point.icon, { size: 24, className: "text-indigo-600" })}
              iconContainerClassName="p-3 bg-indigo-100 border-2 border-black rounded-lg w-fit"
              title={point.title}
              text={point.text}
              titleClassName="text-lg"
              textClassName="text-sm"
              contentClassName="p-6"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

